import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { ModalOptionPanelComponent } from '../../modal-option-panel/modal-option-panel.component';
import { LanguageService } from 'src/app/services/account/language.service';
import { SettingsService } from 'src/app/services/account/settings.service';

@Component({
  standalone: true,
  selector: 'app-account-change-password-step',
  templateUrl: './change-password-step.component.html',
  styleUrls: ['./change-password-step.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, ModalOptionPanelComponent]
})
export class ChangePasswordStepComponent {
  @Input() formGroup: FormGroup | null = null;
  @Input() invalidActualPassword: boolean = false;
  @Input() passwordChangeSuccess: boolean = false;

  showActualPassword = false;
  showNewPassword = false;
  showNewPasswordConfirmation = false;

  constructor(
    public languageService: LanguageService,
    public settingsService: SettingsService
  ) {}

  get actualPassword() { return this.formGroup!.get('actualPassword')!; }
  get newPassword() { return this.formGroup!.get('newPassword')!; }
  get newPasswordConfirmation() { return this.formGroup!.get('newPasswordConfirmation')!; }
  get newPasswordsMatch() { return this.formGroup?.hasError('notSame'); }

  toggleActualPassword(): void {
    this.showActualPassword = !this.showActualPassword;
  }

  toggleNewPassword(): void {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleNewPasswordConfirmation(): void {
    this.showNewPasswordConfirmation = !this.showNewPasswordConfirmation;
  }
}
